import { InjectionToken } from '@angular/core';

export type LazyStylesConfig = {
    isEpcotEnabled: boolean;
};

export const LAZY_STYLES_CONFIG = new InjectionToken<LazyStylesConfig>('LAZY_STYLES_CONFIG');
